
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[channelId]",
      function () {
        return require("private-next-pages/live/[channelId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/[channelId]"])
      });
    }
  